import TableTemplate from "../../../TableTemplate/tableTemplate";
import { IDetailedStateAdjustmentTablesSearchParam } from "../../../../Interfaces/deltaHedgeExe";
import { CommonTableUI } from "../../../TableTemplate/common";
import { getDetailedStateAdjustmentEmergencyOffsetTable } from "../../../../Requests/adjustment";

interface IProps {
  searchParams: IDetailedStateAdjustmentTablesSearchParam;
}

const EmergencyOffset = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDetailedStateAdjustmentTablesSearchParam, any>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          tableBoxClassName="!max-h-[300px] order-table"
        />
      )}
      getDataTable={getDetailedStateAdjustmentEmergencyOffsetTable}
      initialSearchParameters={searchParams}
    />
  );
};

export default EmergencyOffset;
